// import { Checkbox, DatePicker, Flex, Form, Input, message, Select, Spin } from 'antd';
// import React, { useEffect, useRef, useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux';
// import { encodeBase64File } from '../../../../../utils/encodeBase64';
// import PatientService from '../../../../../Services/PatientService';
// import { PlusOutlined } from "@ant-design/icons";
// import UserService from '../../../../../Services/UserService';
// import { clearPatientFilter, handleSetPatientRegistrationPayload } from '../../../../../Redux/actions/patientActions';
// import dayjs from 'dayjs';
// import { CiCamera } from "react-icons/ci";
// import { MdOutlineEdit } from "react-icons/md";
// import regImg from "../../../../../Assets/Images/Group 1000003096.png";
// import CommonService from '../../../../../Services/CommonService';
// import { validatePostalCode } from '../../../../../utils/convertionFunc';
// import { debounce } from 'lodash';

// function Index({ handleCancel, handleSave, handleNext }) {
//   const [profileImage, setProfileImage] = useState(null);
//   const [selectedDoctor, setSelectedDoctor] = useState(null);
//   const [usersList, setUsersList] = useState([]);
//   const [firstLoad, setFirstLoad] = useState(false);
//   const [dob, setDob] = useState();
//   const [fields, setFields] = useState({
//     firstname: '',
//     lastname: '',
//     city: ''
//   });
//   const [isLoading, setIsLoading] = useState(false);
//   const [rpmChecked, setRpmChecked] = useState(false);
//   const [rpmWatchChecked, setRpmWatchChecked] = useState(false);
//   const [omronChecked, setOmronChecked] = useState(false);
//   const [sosChecked, setSosChecked] = useState(false);
//   const [currPageView, setCurrPageView] = useState(1);
//   const [loader, setLoader] = useState(false);
//   const [smartWatchId, setSmartWatchId] = useState('');
//   const [omronId, setOmronId] = useState('');
//   const [citiesList, setCitiesList] = useState([]);
//   const [statesList, setStatesList] = useState([]);
//   const cityRequestRef = useRef(0);
//   const stateRequestRef = useRef(0);
//   const searchTimeoutRef = useRef(null);
//   const stateSearchTimeoutRef = useRef(null);
//   const formRef = useRef();
//   const fileInputRef = useRef(null);
//   const [form] = Form.useForm();
//   const dispatch = useDispatch();
//   const { countries } = useSelector((state) => state.common);
//   const { selectedEditPatient, patientFilter } = useSelector((state) => state.patients);
//   const bloodgroup = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
//   const loggedUserObj = sessionStorage.getItem('login_result');
//   const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
//    const debouncedGetUsers = useRef(
//       debounce((payload) => {
//         getUsersList(payload);
//       }, 300)
//     ).current;

//   useEffect(() => {
//     setFirstLoad(true);
//     getUsersList(null);
//   }, []);

//   useEffect(() => {
//     if (selectedEditPatient) {
//       formRef.current.setFieldsValue({
//         patientId: selectedEditPatient?.patientId,
//         userName: selectedEditPatient?.userName,
//         salutation: selectedEditPatient?.salutation,
//         firstname: selectedEditPatient?.firstName,
//         lastname: selectedEditPatient?.lastName,
//         email: selectedEditPatient?.email,
//         mobile: selectedEditPatient?.mobile,
//         gender: selectedEditPatient?.gender,
//         maritalStatus: selectedEditPatient?.maritalStatus,
//         bloodGroup: selectedEditPatient?.bloodGroup,
//         addressOne: selectedEditPatient?.address1,
//         addressTwo: selectedEditPatient?.address2,
//         city: selectedEditPatient?.city,
//         patientState: selectedEditPatient?.state,
//         country: selectedEditPatient?.country,
//         pincode: selectedEditPatient?.pinCode,
//         dob: selectedEditPatient?.dob ? dayjs(selectedEditPatient?.dob):null,
//         rpmChecked: selectedEditPatient?.rpmApplicable === 'Y' ? true : false,
//         sosChecked: selectedEditPatient?.sos === 'Y' ? true : false,
//         watchChecked: selectedEditPatient?.rpmSmartWatch === "Y" ? true : false,
//         omronDevChecked: selectedEditPatient?.omranConnectYN === "Y" ? true : false,
//         erContactNo1: selectedEditPatient?.erContactNo1,
//         erContactNo2: selectedEditPatient?.erContactNo2,
//         erContactNo3: selectedEditPatient?.erContactNo3,
//         erContactNo4: selectedEditPatient?.erContactNo4,
//         erContactNo5: selectedEditPatient?.erContactNo5,
//       });
//       fetchCities({ city_Name: selectedEditPatient?.city });
//       fetchStates({ state_Id: selectedEditPatient?.state });
//       setDob(selectedEditPatient?.dob);
//       setRpmChecked(selectedEditPatient?.rpmApplicable === 'Y' ? true : false);
//       setSosChecked(selectedEditPatient?.sos === 'Y' ? true : false);
//       setRpmWatchChecked(selectedEditPatient?.rpmSmartWatch === 'Y' ? true : false);
//       setSmartWatchId(selectedEditPatient?.smartWatchUserId);
//       setOmronChecked(selectedEditPatient?.omranConnectYN === 'Y' ? true : false);
//       setOmronId(selectedEditPatient?.omranConnectId);
//     }
//   }, [selectedEditPatient]);

//   useEffect(() => {
//     if (fields.firstname) {
//       const formattedFirstname = fields.firstname.charAt(0).toUpperCase() + fields.firstname.slice(1).toLowerCase();
//       form.setFieldsValue({ firstname: formattedFirstname });
//     }
//     if (fields.lastname) {
//       const formattedLastname = fields.lastname.charAt(0).toUpperCase() + fields.lastname.slice(1).toLowerCase();
//       form.setFieldsValue({ lastname: formattedLastname });
//     }

//     if (fields.city) {
//       const formattedCityName = fields.city.charAt(0).toUpperCase() + fields.city.slice(1).toLowerCase();
//       form.setFieldsValue({ city: formattedCityName });
//     }
//   }, [fields]);

//   const getUsersList = async (filterVal) => {
//     setIsLoading(true);
//     const userPayload = { status: 1 };
//     let finalPayload;
//     if (loggedUser?.user?.rolecode === "ACCT_ADM") {
//       userPayload.account_Id = loggedUser.user.account_Id;
//     }
//     else if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
//       userPayload.account_Id = loggedUser.user.account_Id;
//       userPayload.clinic_Id = loggedUser.user.clinic_Id;
//     }

//     if (filterVal) {
//       finalPayload = {
//         ...userPayload,
//         ...filterVal
//       }
//     }

//     try {
//       const response = await UserService.getUser(filterVal ? finalPayload : userPayload);
//       const doctors = response?.data?.filter((user) => user.userType !== 'S');
//       setUsersList(doctors);
//       setFirstLoad(false);
//       setIsLoading(false);
//     }
//     catch (e) {
//       console.log(e);
//       setIsLoading(false);
//     }

//   };

//   const handleClick = () => {
//     fileInputRef.current.click();
//   };

//   const handleUserPicChange = (e) => {
//     const file = e.target.files[0];
//     if (file && file.size <= 1048576) {
//       setProfileImage(file);
//     } else {
//       message.error("Image/file size should be less than or equal to 1 mb !!");
//       return;
//     }
//   };

//   const handleDob = (value, valueString) => {
//     setDob(valueString);
//   };

//   const validateEmail = (email) =>
//     /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

//   const validatePhoneNumber = (number) =>
//     /^\d{10}$/.test(number);

//   const validatePincode = (pin) =>
//     /^\d{6}$/.test(pin);

//   const handlePatientSave = async () => {
//     const { salutation, firstname, lastname, email, mobile, gender, maritalStatus,
//       bloodGroup, addressOne, addressTwo, city, patientState, country, pincode,
//       erContactNo1, erContactNo2, erContactNo3, erContactNo4, erContactNo5 } = formRef.current.getFieldValue();
//     const currDate = new Date().toISOString();
//     const date = currDate.split("T")[0];
//     const time = currDate.split("T")[1].slice(0, 8);
//     const constructedTime = date + " " + time;

//     if (!selectedEditPatient && !selectedDoctor) {
//       message.error("Please select a doctor!!!");
//       return;
//     }

//     if (!firstname || !lastname || !mobile) {
//       message.error('Please fill in all mandatory fields');
//       return;
//     }

//     if (!validatePhoneNumber(mobile)) {
//       message.error('Please enter a valid 10-digit mobile number.');
//       return;
//     }

//     if (email && !validateEmail(email)) {
//       message.error('Please enter a valid mail id.');
//       return;
//     }
//     if ((pincode && country) && !validatePostalCode(country, pincode)) {
//       message.error('Please enter a valid pincode.');
//       return;
//     }

//     let payload = {};

//     if (sosChecked) {
//       if (!erContactNo1 || !erContactNo2 || !erContactNo3 || !erContactNo4) {
//         message.error("Please fill in all mandatory fields for SOS");
//         return;
//       }
//     }

//     if (rpmWatchChecked && !smartWatchId) {
//       message.error("Please fill in Watch Id");
//       return;
//     }

//     if (omronChecked && !omronId) {
//       message.error("Please fill in Omron connect Id");
//       return;
//     }

//     if (selectedEditPatient) {
//       payload = {
//         ...selectedEditPatient,
//         address1: addressOne ? addressOne : null,
//         address2: addressTwo ? addressTwo : null,
//         bloodGroup: bloodGroup ? bloodGroup : null,
//         city: city ? city : null,
//         country: country ? country : null,
//         dob: dob ? dob : null,
//         email: email ? email : null,
//         firstName: firstname,
//         gender,
//         lastName: lastname,
//         maritalStatus: maritalStatus ? maritalStatus : null,
//         mobile,
//         modifiedBy: loggedUser?.user?.userId,
//         modifiedDate: constructedTime,
//         pinCode: pincode ? pincode : null,
//         salutation: salutation ? salutation : null,
//         state: patientState ? patientState : null,
//         status: 1,
//         rpmApplicable: rpmChecked ? 'Y' : 'N',
//         patientChronicConditionsList: selectedEditPatient?.patientChronicConditionsList,
//         patientDevicesList: selectedEditPatient?.patientDevicesList,
//         patientVitalsConfigList: selectedEditPatient?.patientVitalsConfigList,
//         patientVitalsRangeList: selectedEditPatient?.patientVitalsRangeList,
//         hospitalId: selectedEditPatient?.hospitalId,
//         locationId: selectedEditPatient?.locationId,
//         uhId: selectedEditPatient?.hospitalId,
//         insuranceId1: selectedEditPatient?.insuranceId1,
//         insuranceId2: selectedEditPatient?.insuranceId2,
//         insuranceName1: selectedEditPatient?.insuranceName1,
//         insuranceName2: selectedEditPatient?.insuranceName2,
//         patientGroupNumber: selectedEditPatient?.patientGroupNumber,
//         height: selectedEditPatient?.height,
//         weight: selectedEditPatient?.weight,
//         providerName: selectedEditPatient?.providerName,
//         providerCode: selectedEditPatient?.providerCode,
//         patientRegConsentDtlList: selectedEditPatient?.patientRegConsentDtlList,
//         sos: sosChecked ? 'Y' : 'N',
//         erContactNo1: erContactNo1 ? erContactNo1 : selectedEditPatient?.erContactNo1,
//         erContactNo2: erContactNo2 ? erContactNo2 : selectedEditPatient?.erContactNo2,
//         erContactNo3: erContactNo3 ? erContactNo3 : selectedEditPatient?.erContactNo3,
//         erContactNo4: erContactNo4 ? erContactNo4 : selectedEditPatient?.erContactNo4,
//         erContactNo5: erContactNo5 ? erContactNo5 : "",
//         rpmSmartWatch: rpmWatchChecked ? 'Y' : 'N',
//         smartWatchUserId: smartWatchId ? smartWatchId !== selectedEditPatient?.smartWatchUserId ? smartWatchId : selectedEditPatient?.smartWatchUserId : selectedEditPatient?.smartWatchUserId,
//         omranConnectYN: omronChecked ? 'Y' : 'N',
//         omranConnectId: omronId ? omronId !== selectedEditPatient?.omranConnectId ? omronId : selectedEditPatient?.omranConnectId : selectedEditPatient?.omranConnectId
//       }
//     }
//     else {
//       payload = {
//         account_Id: selectedDoctor?.account_Id,
//         account_Name: null,
//         address1: addressOne ? addressOne : null,
//         address2: addressTwo ? addressTwo : null,
//         bloodGroup: bloodGroup ? bloodGroup : null,
//         city: city ? city : null,
//         clinic_Id: selectedDoctor?.clinic_Id,
//         clinic_Name: null,
//         country: country ? country : null,
//         createdBy: loggedUser?.user?.userId,
//         createdDate: constructedTime,
//         dob: dob ? dob : null,
//         email: email ? email : null,
//         firstName: firstname,
//         gender,
//         lastName: lastname,
//         loginId: null,
//         loginIdAvailableYN: null,
//         maritalStatus: maritalStatus ? maritalStatus : null,
//         meetingLink: null,
//         mobile,
//         modifiedBy: loggedUser?.user?.userId,
//         modifiedDate: constructedTime,
//         parentPatientId: null,
//         parentPatientName: null,
//         patientId: null,
//         patientRegFee: 0,
//         patientRegFeeYN: null,
//         photo: null,
//         photoName: null,
//         photoType: null,
//         pinCode: pincode ? pincode : null,
//         relationCode: null,
//         relationDescription: null,
//         salutation: salutation ? salutation : null,
//         state: patientState ? patientState : null,
//         status: 1,
//         userId: selectedDoctor?.userId,
//         userName: selectedDoctor?.userName,
//         rpmApplicable: rpmChecked ? 'Y' : 'N',
//         patientChronicConditionsList: [],
//         patientDevicesList: [],
//         patientVitalsConfigList: {
//           bloodGlucose: 0,
//           bmi: 1,
//           diastolic: 1,
//           heartRate: 0,
//           height: 1,
//           respiratoryRate: 0,
//           spo2: 0,
//           systolic: 1,
//           temperature: 0,
//           weight: 1,
//           breathing: 1,
//           pulse: 1,
//           spirometry: 1,
//           createdBy: "",
//           modifiedBy: "",
//           status: 1
//         },
//         patientVitalsRangeList: [],
//         hospitalId: "",
//         locationId: "",
//         uhId: "",
//         insuranceId1: "",
//         insuranceId2: "",
//         insuranceName1: "",
//         insuranceName2: "",
//         patientGroupNumber: "",
//         height: 0,
//         weight: 0,
//         providerName: "",
//         providerCode: "",
//         patientRegConsentDtlList: [],
//         sos: sosChecked ? 'Y' : 'N',
//         erContactNo1: erContactNo1 ? erContactNo1 : "",
//         erContactNo2: erContactNo2 ? erContactNo2 : "",
//         erContactNo3: erContactNo3 ? erContactNo3 : "",
//         erContactNo4: erContactNo4 ? erContactNo4 : "",
//         erContactNo5: erContactNo5 ? erContactNo5 : "",
//         rpmSmartWatch: rpmWatchChecked ? 'Y' : 'N',
//         smartWatchUserId: smartWatchId,
//         omranConnectYN: omronChecked ? 'Y' : 'N',
//         omranConnectId: omronId
//       }
//     }

//     if (profileImage) {
//       const res = await encodeBase64File(profileImage);
//       payload.imageName = profileImage.name;
//       if (profileImage?.type.includes("pdf")) {
//         payload.photoType = "pdf";
//         payload.photo = res;
//       } else if (profileImage?.type.includes("png")) {
//         payload.photoType = "png";
//         payload.photo = res;
//       } else if (profileImage?.type.includes("jpg")) {
//         payload.photoType = "jpg";
//         payload.photo = res;
//       } else if (profileImage?.type.includes("jpeg")) {
//         payload.photoType = "jpeg";
//         payload.photo = res;
//       }
//     }

//     if (rpmChecked) {
//       dispatch(handleSetPatientRegistrationPayload(payload));
//       handleNext();
//     }
//     else {
//       if (selectedEditPatient) {
//         setLoader(true);
//         try {
//           await PatientService.EditPatientData(payload);
//           message.success('Patient Details updated successfully!!');
//           setProfileImage(null);
//           formRef.current.resetFields();
//           setLoader(false);
//           handleSave();
//           if (patientFilter) dispatch(clearPatientFilter(false));
//         }
//         catch (e) {
//           setLoader(false);
//           console.log(e);
//         }
//       }
//       else {
//         setLoader(true);
//         try {
//           await PatientService.AddPatient(payload);
//           message.success('Patient created successfully!!');
//           setProfileImage(null);
//           formRef.current.resetFields();
//           handleSave();
//           setLoader(false);
//         }
//         catch (e) {
//           setLoader(false);
//           console.log(e);
//           e && message.error(e.response.data.message);
//         }
//       }

//     }

//   }

//   const handleSelectDoctor = (userid) => {
//     if (!userid) return;
//     const selectedUser = usersList.find((user) => user.userId === userid);
//     setSelectedDoctor(selectedUser);
//   }

//   const handleDocSearch = async (label) => {
//     if (label && label.length >= 2) {
//       const payload = {
//         userName: label
//       }
//       debouncedGetUsers(payload);
//     }
//     else {
//       debouncedGetUsers(null);
//     }
//   }

//   const handleRpmChange = () => {
//     setRpmChecked(!rpmChecked);
//   }

//   const handleRpmWatchChange = () => {
//     setRpmWatchChecked(!rpmWatchChecked);
//   }

//   const handleOmronChange = () => {
//     setOmronChecked(!omronChecked);
//   }

//   const handleSosChange = () => {
//     setSosChecked(!sosChecked);
//   }

//   const handleSmartWatchId = (e) => {
//     const value = e.target.value;
//     setSmartWatchId(value);
//   }

//   const handleOmronId = (e) => {
//     const value = e.target.value;
//     setOmronId(value);
//   }

//   const fetchCities = async (filterValues) => {
//     const requestId = ++cityRequestRef.current;
//     const payload = {
//       status: 1
//     };

//     let finalPayload;

//     if (filterValues) {
//       finalPayload = {
//         ...payload,
//         ...filterValues
//       }
//     }

//     try {
//       const res = await CommonService.CitiesList(filterValues ? finalPayload : payload);
//       if (requestId !== cityRequestRef.current) return;
//       setCitiesList(res.data || []);
//     }
//     catch (e) {
//       console.log(e);
//     }
//   }

//   const fetchStates = async (filterValues) => {
//     const requestId = ++stateRequestRef.current;
//     const payload = {
//       status: 1
//     };

//     let finalPayload;

//     if (filterValues) {
//       finalPayload = {
//         ...payload,
//         ...filterValues
//       }
//     }

//     try {
//       const res = await CommonService.StatesList(filterValues ? finalPayload : payload);
//       if (requestId !== stateRequestRef.current) return;
//       setStatesList(res.data || []);
//     }
//     catch (e) {
//       console.log(e);
//     }
//   }

//   const handleSearchCities = async (value) => {
//     if (!value) {
//       setCitiesList([]);
//       return;
//     }
//     if (searchTimeoutRef.current) {
//       clearTimeout(searchTimeoutRef.current);
//     }

//     searchTimeoutRef.current = setTimeout(() => {
//       fetchCities({ city_Name: value });
//     }, 400);
//   }

//   const handleStateChange = async (value) => {
//     if (!value) {
//       setCitiesList([]);
//       return;
//     }
//     setCitiesList([]);
//     const payload = {
//       state_Id: value
//     }
//     try {
//       await fetchCities(payload);
//     }
//     catch (e) {
//       console.log(e);
//     }
//   }

//   const handleSearchStates = async (value) => {
//     if (!value) {
//       setStatesList([]);
//       return;
//     }
//     if (stateSearchTimeoutRef.current) {
//       clearTimeout(stateSearchTimeoutRef.current);
//     }

//     stateSearchTimeoutRef.current = setTimeout(() => {
//       fetchStates({ state_Name: value });
//     }, 400);
//   }

//   const handleCountryChange = async (value) => {
//     if (!value) {
//       setStatesList([]);
//       return;
//     }
//     setStatesList([]);
//     const payload = {
//       country_Id: value
//     }
//     try {
//       await fetchStates(payload);
//     }
//     catch (e) {
//       console.log(e);
//     }
//   }

//   return (
//     <>
//       {firstLoad ? (
//         <div className="min-h-[50vh] flex items-center justify-center mt-[10%]">
//           <Flex align="center" gap="middle">
//             <Spin size="large" tip="Loading" />
//           </Flex>
//         </div>
//       ) : (
//         <>
//           <div>
//             <Form
//               ref={formRef}
//               form={form}
//               disabled={loader}
//               className="w-full border rounded-md  "
//             >
//               <div className="flex justify-between bg-[#F6FEFF] px-4 py-2 border-b">
//                 <div
//                   className="flex items-center gap-3 cursor-pointer"
//                   onClick={handleClick}
//                 >
//                   <div className="relative w-28 h-28">
//                     <input
//                       type="file"
//                       style={{ display: "none" }}
//                       onChange={handleUserPicChange}
//                       ref={fileInputRef}
//                     />

//                     {profileImage ? (
//                       <img
//                         src={URL.createObjectURL(profileImage)}
//                         alt="Profile"
//                         className="w-28 h-28 object-cover rounded-full border"
//                       />
//                     ) : selectedEditPatient?.photoName ? (
//                       <img
//                         src={
//                           process.env.REACT_APP_IMAGE_URL +
//                           selectedEditPatient?.photoName
//                         }
//                         alt="Profile"
//                         className="w-28 h-28 object-cover rounded-full border"
//                       />
//                     ) : (
//                       <div className="w-28 h-28 flex items-center justify-center rounded-full border bg-gray-100">
//                         <span className="text-gray-500">No Image</span>
//                       </div>
//                     )}
//                   </div>

//                   <button className="bg-white border px-3 py-1 rounded-md font-semibold text-sm shadow-sm">
//                     <span className="flex gap-2 items-center">
//                       {profileImage || selectedEditPatient?.photoName ? (
//                         <>
//                           <MdOutlineEdit /> <span>Edit Photo</span>
//                         </>
//                       ) : (
//                         <>
//                           <CiCamera /> <span>Upload Photo</span>
//                         </>
//                       )}
//                     </span>
//                   </button>
//                 </div>

//                 <img src={regImg} alt="img" />
//               </div>

//               {/* Doctor Details */}
//               <div className="md:text-xl text-base font-medium px-4 my-2">
//                 User Details
//               </div>

//               <div className="w-full grid md:grid-cols-3 grid-cols-1 gap-4 px-4">
//                 <div className="relative">
//                   <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                     Referral User  <span className="text-red-500">*</span>
//                   </span>
//                   {
//                     selectedEditPatient ?
//                       (
//                         <Form.Item name="userName" className="mt-1">
//                           <Input type="text" className="rounded-md px-4 py-2" disabled={true} />
//                         </Form.Item>
//                       )
//                       :
//                       (
//                         <Form.Item className="mt-1">
//                           <Select
//                             placeholder="Select User"
//                             className="rounded-md h-10"
//                             onChange={handleSelectDoctor}
//                             onSearch={handleDocSearch}
//                             showSearch
//                             allowClear
//                             options={usersList?.map((user, idx) => {
//                               return {
//                                 label: `${user.firstName} ${user.lastName}`,
//                                 value: user.userId,
//                                 key: idx
//                               }
//                             })}
//                             filterOption={false}
//                             onClear={handleDocSearch}
//                             notFoundContent={
//                               isLoading ?
//                                 <div className='flex justify-center'><Spin /></div> :
//                                 <span>No data found</span>
//                             }
//                           />
//                         </Form.Item>
//                       )
//                   }
//                 </div>
//               </div>

//               {/* Personal Details */}
//               <div className="md:text-xl text-base font-medium px-4 my-2">
//                 Personal Details
//               </div>

//               <div className="w-full grid md:grid-cols-3 grid-cols-1 gap-4 px-4">
//                 {/* SALUTATION */}
//                 <div className="relative">
//                   <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                     Salutation
//                   </span>
//                   <Form.Item name="salutation" className="mt-1">
//                     <Select
//                       //placeholder="Select Salutation"
//                       className="rounded-md h-10"
//                       allowClear
//                     >
//                       <Select.Option value="Mr.">Mr</Select.Option>
//                       <Select.Option value="Miss.">Miss</Select.Option>
//                       <Select.Option value="Mrs.">Mrs</Select.Option>
//                     </Select>
//                   </Form.Item>
//                 </div>

//                 {/* FIRST NAME */}
//                 <div className="relative">
//                   <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                     First Name <span className="text-red-500">*</span>
//                   </span>
//                   <Form.Item name="firstname" className="mt-1">
//                     <Input
//                       //placeholder="First Name"
//                       className="rounded-md px-4 py-2"
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         const formattedValue =
//                           value.charAt(0).toUpperCase() +
//                           value.slice(1).toLowerCase();
//                         setFields((prev) => ({
//                           ...prev,
//                           firstname: formattedValue,
//                         }));
//                       }}
//                     />
//                   </Form.Item>
//                 </div>

//                 {/* LAST NAME */}
//                 <div className="relative">
//                   <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                     Last Name <span className="text-red-500">*</span>
//                   </span>
//                   <Form.Item name="lastname" className="mt-1">
//                     <Input
//                       //placeholder="Last Name"
//                       className="rounded-md px-4 py-2"
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         const formattedValue =
//                           value.charAt(0).toUpperCase() +
//                           value.slice(1).toLowerCase();
//                         setFields((prev) => ({
//                           ...prev,
//                           lastname: formattedValue,
//                         }));
//                       }}
//                     />
//                   </Form.Item>
//                 </div>

//                 {/* MOBILE */}
//                 <div className="relative">
//                   <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                     Mobile <span className="text-red-500">*</span>
//                   </span>
//                   <Form.Item name="mobile" className="mt-1">
//                     <Input
//                       //placeholder="Enter mobile number"
//                       maxLength={10}
//                       className="rounded-md px-4 py-2"
//                       onKeyDown={(e) => {
//                         const allowedKeys = [
//                           "Backspace",
//                           "Delete",
//                           "Tab",
//                           "ArrowLeft",
//                           "ArrowRight",
//                         ];
//                         if (
//                           !/[0-9]/.test(e.key) &&
//                           !allowedKeys.includes(e.key)
//                         ) {
//                           e.preventDefault();
//                         }
//                       }}
//                     />
//                   </Form.Item>
//                 </div>

//                 {/* EMAIL */}
//                 <div className="relative">
//                   <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                     Email
//                   </span>
//                   <Form.Item name="email" className="mt-1">
//                     <Input
//                       type="email"
//                       //placeholder="Enter email"
//                       className="rounded-md px-4 py-2"
//                     />
//                   </Form.Item>
//                 </div>

//                 {/* DOB */}
//                 <div className="relative">
//                   <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                     Date of Birth
//                   </span>
//                   <Form.Item name="dob" className="mt-1">
//                     <DatePicker
//                       className="w-full rounded-md px-2 py-2"
//                       format="MM/DD/YYYY"
//                       //placeholder="Date of Birth"
//                       onChange={handleDob}
//                       disabledDate={(current) =>
//                         current && current > Date.now()
//                       }
//                     />
//                   </Form.Item>
//                 </div>

//                 {/* GENDER */}
//                 <div className="relative">
//                   <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                     Gender
//                   </span>
//                   <Form.Item name="gender" className="mt-1">
//                     <Select
//                       //placeholder="Select Gender"
//                       className="rounded-md h-10"
//                       allowClear
//                     >
//                       <Select.Option value="M">Male</Select.Option>
//                       <Select.Option value="F">Female</Select.Option>
//                     </Select>
//                   </Form.Item>
//                 </div>

//                 {/* MARITAL */}
//                 <div className="relative">
//                   <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                     Marital Status
//                   </span>
//                   <Form.Item name="maritalStatus" className="mt-1">
//                     <Select
//                       //placeholder="Marital Status"
//                       className="rounded-md h-10"
//                       allowClear
//                     >
//                       <Select.Option value="M">Married</Select.Option>
//                       <Select.Option value="U">Unmarried</Select.Option>
//                     </Select>
//                   </Form.Item>
//                 </div>

//                 {/* BLOOD GROUP */}
//                 <div className="relative">
//                   <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                     Blood Group
//                   </span>
//                   <Form.Item name="bloodGroup" className="mt-1">
//                     <Select
//                       //placeholder="Blood Group"
//                       className="rounded-md h-10"
//                       allowClear
//                     >
//                       {bloodgroup.map((b) => (
//                         <Select.Option key={b} value={b}>
//                           {b}
//                         </Select.Option>
//                       ))}
//                     </Select>
//                   </Form.Item>
//                 </div>
//               </div>

//               {/* Address Title */}
//               <div className="md:text-xl text-base font-medium px-4 my-2">
//                 Address Details
//               </div>

//               {/* Address Fields */}
//               <div className="w-full grid md:grid-cols-4 grid-cols-1 gap-4 px-4">
//                 {/* ADDRESS 1 */}
//                 <div className="relative">
//                   <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                     Address 1
//                   </span>
//                   <Form.Item name="addressOne" className="mt-1">
//                     <Input
//                       //placeholder="Address 1"
//                       className="rounded-md px-4 py-2"
//                     />
//                   </Form.Item>
//                 </div>

//                 {/* ADDRESS 2 */}
//                 <div className="relative">
//                   <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                     Address 2
//                   </span>
//                   <Form.Item name="addressTwo" className="mt-1">
//                     <Input
//                       //placeholder="Address 2"
//                       className="rounded-md px-4 py-2"
//                     />
//                   </Form.Item>
//                 </div>

//                 {/* CITY */}
//                 <div className="relative">
//                   <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                     City
//                   </span>
//                   <Form.Item name="city" className="mt-1">
//                     {/* <Input
//                       //placeholder="City"
//                       className="rounded-md px-4 py-2"
//                       onChange={(e) => {
//                         const value = e.target.value;
//                         const formattedValue =
//                           value.charAt(0).toUpperCase() +
//                           value.slice(1).toLowerCase();
//                         setFields((prev) => ({
//                           ...prev,
//                           city: formattedValue,
//                         }));
//                       }}
//                       onKeyDown={(e) => {
//                         const allowedKeys = [
//                           "Backspace",
//                           "Delete",
//                           "Tab",
//                           "ArrowLeft",
//                           "ArrowRight",
//                         ];
//                         if (
//                           !/^[a-zA-Z]$/.test(e.key) &&
//                           !allowedKeys.includes(e.key)
//                         ) {
//                           e.preventDefault();
//                         }
//                       }}
//                     /> */}
//                     <Select
//                       showSearch
//                       className="rounded-md h-10"
//                       options={citiesList?.map((city) => {
//                         return {
//                           label: city.cityName,
//                           value: city.cityName,
//                           key: city.id
//                         };
//                       })}
//                       onSearch={handleSearchCities}
//                       filterOption={false}
//                       allowClear
//                     />
//                   </Form.Item>
//                 </div>

//                 {/* STATE */}
//                 <div className="relative">
//                   <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                     State
//                   </span>
//                   <Form.Item name="patientState" className="mt-1">
//                     <Select
//                       showSearch
//                       className="rounded-md h-10"
//                       options={statesList?.map((state) => {
//                         return {
//                           label: state.stateName,
//                           value: state.stateId,
//                           key: state.id
//                         };
//                       })}
//                       onChange={handleStateChange}
//                       onSearch={handleSearchStates}
//                       filterOption={false}
//                       allowClear
//                     // filterOption={(input, option) => (option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0)}
//                     />
//                   </Form.Item>
//                 </div>

//                 {/* COUNTRY */}
//                 <div className="relative">
//                   <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                     Country
//                   </span>
//                   <Form.Item name="country" className="mt-1">
//                     <Select
//                       showSearch
//                       className="rounded-md h-10"
//                       onChange={handleCountryChange}
//                       options={countries?.map((country) => {
//                         return {
//                           label: country.country_Name,
//                           value: country.country_Id,
//                           key: country.id
//                         }
//                       })}
//                       filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
//                       allowClear
//                     />
//                   </Form.Item>
//                 </div>

//                 {/* PINCODE */}
//                 <div className="relative">
//                   <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                     Pincode
//                   </span>
//                   <Form.Item name="pincode" className="mt-1">
//                     <Input
//                       //placeholder="Pincode"
//                       // maxLength={6}
//                       className="rounded-md px-4 py-2"
//                       onKeyDown={(e) => {
//                         const allowedKeys = [
//                           "Backspace",
//                           "Delete",
//                           "Tab",
//                           "ArrowLeft",
//                           "ArrowRight",
//                         ];
//                         if (
//                           !/[0-9]/.test(e.key) &&
//                           !allowedKeys.includes(e.key)
//                         ) {
//                           e.preventDefault();
//                         }
//                       }}
//                     />
//                   </Form.Item>
//                 </div>

//                 {/* Rpm Checkbox */}
//                 <div className="flex gap-2">
//                   <Form.Item valuePropName="checked" name="rpmChecked">
//                     <Checkbox onChange={handleRpmChange} />
//                   </Form.Item>
//                   <div className="">
//                     <label className="md:text-lg text-base font-medium">
//                       RPM
//                     </label>
//                   </div>
//                 </div>

//                 {/* Sos checkbox */}
//                 <div className="flex gap-2">
//                   <Form.Item valuePropName="checked" name="sosChecked">
//                     <Checkbox onChange={handleSosChange} />
//                   </Form.Item>
//                   <label className="md:text-lg text-base font-medium">
//                     SOS
//                   </label>
//                 </div>

//                 {sosChecked && (
//                   <>
//                     <div className="relative">
//                       <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                         Contact 1<span className="text-red-500">*</span>
//                       </span>
//                       <Form.Item name="erContactNo1">
//                         <Input
//                           //placeholder="Emergency Contact No 1"
//                           name="erContactNo1"
//                           className="rounded-md px-4 py-2"
//                           maxLength={10}
//                           onKeyDown={(event) => {
//                             const allowedKeys = [
//                               "Backspace",
//                               "Delete",
//                               "Tab",
//                               "ArrowLeft",
//                               "ArrowRight",
//                             ];

//                             if (
//                               !/[0-9]/.test(event.key) &&
//                               !allowedKeys.includes(event.key)
//                             ) {
//                               event.preventDefault(); // Prevent non-numeric and non-control key input
//                             }
//                           }}
//                         />
//                       </Form.Item>
//                     </div>

//                     <div className="relative">
//                       <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                         Contact 2<span className="text-red-500">*</span>
//                       </span>
//                       <Form.Item name="erContactNo2">
//                         <Input
//                           //placeholder="Emergency Contact No 2"
//                           name="erContactNo2"
//                           className="rounded-md px-4 py-2"
//                           maxLength={10}
//                           onKeyDown={(event) => {
//                             const allowedKeys = [
//                               "Backspace",
//                               "Delete",
//                               "Tab",
//                               "ArrowLeft",
//                               "ArrowRight",
//                             ];

//                             if (
//                               !/[0-9]/.test(event.key) &&
//                               !allowedKeys.includes(event.key)
//                             ) {
//                               event.preventDefault(); // Prevent non-numeric and non-control key input
//                             }
//                           }}
//                         />
//                       </Form.Item>
//                     </div>

//                     <div className="relative">
//                       <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                         Contact 3<span className="text-red-500">*</span>
//                       </span>
//                       <Form.Item name="erContactNo3">
//                         <Input
//                           //placeholder="Emergency Contact No 3"
//                           name="erContactNo3"
//                           className="rounded-md px-4 py-2"
//                           maxLength={10}
//                           onKeyDown={(event) => {
//                             const allowedKeys = [
//                               "Backspace",
//                               "Delete",
//                               "Tab",
//                               "ArrowLeft",
//                               "ArrowRight",
//                             ];

//                             if (
//                               !/[0-9]/.test(event.key) &&
//                               !allowedKeys.includes(event.key)
//                             ) {
//                               event.preventDefault(); // Prevent non-numeric and non-control key input
//                             }
//                           }}
//                         />
//                       </Form.Item>
//                     </div>

//                     <div className="relative">
//                       <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                         Contact 4<span className="text-red-500">*</span>
//                       </span>
//                       <Form.Item name="erContactNo4">
//                         <Input
//                           //placeholder="Emergency Contact No 4"
//                           name="erContactNo4"
//                           className="rounded-md px-4 py-2"
//                           maxLength={10}
//                           onKeyDown={(event) => {
//                             const allowedKeys = [
//                               "Backspace",
//                               "Delete",
//                               "Tab",
//                               "ArrowLeft",
//                               "ArrowRight",
//                             ];

//                             if (
//                               !/[0-9]/.test(event.key) &&
//                               !allowedKeys.includes(event.key)
//                             ) {
//                               event.preventDefault(); // Prevent non-numeric and non-control key input
//                             }
//                           }}
//                         />
//                       </Form.Item>
//                     </div>

//                     <div className="relative">
//                       <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                         Contact 5 (Medical Contact)
//                       </span>
//                       <Form.Item name="erContactNo5">
//                         <Input
//                           //placeholder="Emergency Contact No 5"
//                           name="erContactNo5"
//                           className="rounded-md px-4 py-2"
//                           maxLength={10}
//                           onKeyDown={(event) => {
//                             const allowedKeys = [
//                               "Backspace",
//                               "Delete",
//                               "Tab",
//                               "ArrowLeft",
//                               "ArrowRight",
//                             ];

//                             if (
//                               !/[0-9]/.test(event.key) &&
//                               !allowedKeys.includes(event.key)
//                             ) {
//                               event.preventDefault(); // Prevent non-numeric and non-control key input
//                             }
//                           }}
//                         />
//                       </Form.Item>
//                     </div>
//                   </>
//                 )}
//               </div>

//               {/* Rpm Watch */}
//               <div className="w-full grid md:grid-cols-4 grid-cols-1 gap-4 px-4">
//                 {/* Rpm-watch Checkbox */}
//                 <div className="flex gap-2">
//                   <Form.Item valuePropName="checked" name="watchChecked">
//                     <Checkbox checked={rpmWatchChecked} onChange={handleRpmWatchChange} />
//                   </Form.Item>
//                   <div className="">
//                     <label className="md:text-lg text-base font-medium">
//                       Rpm-Watch
//                     </label>
//                   </div>
//                 </div>
//                 {
//                   rpmWatchChecked &&

//                   (
//                     <div className="relative">
//                       <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                         Watch Id
//                       </span>
//                       <Form.Item>
//                         <Input
//                           placeholder="Enter watch-Id"
//                           name="watch"
//                           value={smartWatchId}
//                           onChange={handleSmartWatchId}
//                           className="rounded-md px-4 py-2"
//                         />
//                       </Form.Item>
//                     </div>
//                   )
//                 }
//               </div>

//               {/* Omron device */}
//               <div className="w-full grid md:grid-cols-4 grid-cols-1 gap-4 px-4">
//                 {/* Omron Checkbox */}
//                 <div className="flex gap-2">
//                   <Form.Item valuePropName="checked" name="omronDevChecked">
//                     <Checkbox checked={omronChecked} onChange={handleOmronChange} />
//                   </Form.Item>
//                   <div className="">
//                     <label className="md:text-lg text-base font-medium">
//                       Omron Device
//                     </label>
//                   </div>
//                 </div>
//                 {
//                   omronChecked &&

//                   (
//                     <div className="relative">
//                       <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
//                         Omron Id
//                       </span>
//                       <Form.Item>
//                         <Input
//                           placeholder="Enter Omron-Id"
//                           name="omronDevice"
//                           value={omronId}
//                           onChange={handleOmronId}
//                           className="rounded-md px-4 py-2"
//                         />
//                       </Form.Item>
//                     </div>
//                   )
//                 }
//               </div>
//             </Form>
//           </div>
//           <div className="flex md:flex-row text-center flex-col md:items-center items-end justify-end gap-3 mt-4">
//             <button
//               disabled={loader}
//               className="md:min-w-24 w-[3rem] md:w-24  h-8 p-1 bg-white rounded-lg border text-brand-primaryColor border-brand-primaryColor font-semibold custom-button-shadow"
//               onClick={handleCancel}
//             >
//               Cancel
//             </button>
//             <button
//               disabled={loader}
//               className="md:min-w-24 w-[3rem] md:w-24  h-8 p-1 custom_filter text-white rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50"
//               onClick={handlePatientSave}
//             >
//               {rpmChecked || currPageView !== 1
//                 ? "Next"
//                 : selectedEditPatient
//                   ? "Update"
//                   : "Save"}
//             </button>
//           </div>
//         </>
//       )}
//     </>
//   );
// }

// export default Index;

// Patient basic details
import {
  Avatar,
  Checkbox,
  DatePicker,
  Flex,
  Form,
  Input,
  message,
  Select,
  Spin,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { encodeBase64File } from "../../../../../utils/encodeBase64";
import PatientService from "../../../../../Services/PatientService";
import { PlusOutlined } from "@ant-design/icons";
import UserService from "../../../../../Services/UserService";
import dayjs from "dayjs";
import { CiCamera } from "react-icons/ci";
import { MdOutlineEdit } from "react-icons/md";
import regImg from "../../../../../Assets/Images/Group 1000003096.png";
import CommonService from "../../../../../Services/CommonService";
import { validatePostalCode } from "../../../../../utils/convertionFunc";
import { debounce } from "lodash";
import {
  clearPatientFilter,
  handleSetPatientRegistrationPayload,
} from "../../../../../Redux/actions/patientActions";

function PatientBasicDetails({ handleCancel, handleSave, handleNext }, ref) {
  const [profileImage, setProfileImage] = useState(null);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [usersList, setUsersList] = useState([]);
  const [firstLoad, setFirstLoad] = useState(false);
  const [dob, setDob] = useState();
  const [fields, setFields] = useState({
    firstname: "",
    lastname: "",
    city: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [rpmChecked, setRpmChecked] = useState(false);
  const [rpmWatchChecked, setRpmWatchChecked] = useState(false);
  const [omronChecked, setOmronChecked] = useState(false);
  const [sosChecked, setSosChecked] = useState(false);
  const [loader, setLoader] = useState(false);
  const [smartWatchId, setSmartWatchId] = useState("");
  const [omronId, setOmronId] = useState("");
  const [citiesList, setCitiesList] = useState([]);
  const [statesList, setStatesList] = useState([]);

  const cityRequestRef = useRef(0);
  const stateRequestRef = useRef(0);
  const searchTimeoutRef = useRef(null);
  const stateSearchTimeoutRef = useRef(null);
  const formRef = useRef();
  const fileInputRef = useRef(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { countries } = useSelector((state) => state.common);
  const { selectedEditPatient, patientFilter } = useSelector(
    (state) => state.patients,
  );
  const { registrationPayload } = useSelector((state) => state.patients);

  const bloodgroup = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  const debouncedGetUsers = useRef(
    debounce((payload) => getUsersList(payload), 300),
  ).current;

  // ── Expose collectValues to parent via ref ──────────────────────────────────
  // Parent calls this before switching tabs — builds partial payload → Redux

  useImperativeHandle(ref, () => ({

    collectValues: () => {
      if (!formRef.current) return;
      const vals = formRef.current.getFieldsValue();
      const currDate = new Date().toISOString().slice(0, 19).replace("T", " ");

      const basePayload = registrationPayload || {};

      const partial = {
        ...basePayload,
        firstName: vals.firstname || basePayload.firstName || "",
        lastName: vals.lastname || basePayload.lastName || "",
        mobile: vals.mobile || basePayload.mobile || "",
        email: vals.email || basePayload.email || null,
        salutation: vals.salutation || basePayload.salutation || null,
        gender: vals.gender || basePayload.gender || null,
        maritalStatus: vals.maritalStatus || basePayload.maritalStatus || null,
        bloodGroup: vals.bloodGroup || basePayload.bloodGroup || null,
        address1: vals.addressOne || basePayload.address1 || null,
        address2: vals.addressTwo || basePayload.address2 || null,
        city: vals.city || basePayload.city || null,
        state: vals.patientState || basePayload.state || null,
        country: vals.country || basePayload.country || null,
        pinCode: vals.pincode || basePayload.pinCode || null,
        dob: dob || basePayload.dob || null,
        rpmApplicable: rpmChecked ? "Y" : "N",
        sos: sosChecked ? "Y" : "N",
        erContactNo1: vals.erContactNo1 || basePayload.erContactNo1 || "",
        erContactNo2: vals.erContactNo2 || basePayload.erContactNo2 || "",
        erContactNo3: vals.erContactNo3 || basePayload.erContactNo3 || "",
        erContactNo4: vals.erContactNo4 || basePayload.erContactNo4 || "",
        erContactNo5: vals.erContactNo5 || basePayload.erContactNo5 || "",
        rpmSmartWatch: rpmWatchChecked ? "Y" : "N",
        smartWatchUserId: smartWatchId || basePayload.smartWatchUserId || "",
        omranConnectYN: omronChecked ? "Y" : "N",
        omranConnectId: omronId || basePayload.omranConnectId || "",
        createdBy: loggedUser?.user?.userId,
        modifiedBy: loggedUser?.user?.userId,
        createdDate: currDate,
        modifiedDate: currDate,
        status: 1,
      };

      // Only add userId/account info if a doctor was selected (new patient)
      if (!selectedEditPatient) {
        if (selectedDoctor) {
          partial.referralUserId = selectedDoctor.userId;
          partial.referralUserName = selectedDoctor.userName;
          partial.account_Id = selectedDoctor.account_Id;
          partial.clinic_Id = selectedDoctor.clinic_Id;
          // partial.createdBy = loggedUser?.user?.userId;
          // partial.createdDate = currDate;
        } else {
          // Superadmin's info
          const accountId = "77778888999";
          const clinicId = "C555566667777";
          const userId = "DOXZONADMIN";
          const userName = "Admin";
          partial.referralUserId = userId;
          partial.referralUserName = userName;
          partial.account_Id = accountId;
          partial.clinic_Id = clinicId;
        }
      }

      if (profileImage) {
        partial.photoName = profileImage.name;
        partial.photoType = profileImage.type;
        partial.photo = profileImage.base64;
    }

      dispatch(handleSetPatientRegistrationPayload(partial));
    },
  }));

  // ── Effects ─────────────────────────────────────────────────────────────────

  useEffect(() => {
    setFirstLoad(true);
    getUsersList(null);
  }, []);

  useEffect(() => {
    if (selectedEditPatient) {
      formRef.current.setFieldsValue({
        patientId: selectedEditPatient?.patientId,
        userName: selectedEditPatient?.userName,
        salutation: selectedEditPatient?.salutation,
        firstname: selectedEditPatient?.firstName,
        lastname: selectedEditPatient?.lastName,
        email: selectedEditPatient?.email,
        mobile: selectedEditPatient?.mobile,
        gender: selectedEditPatient?.gender,
        maritalStatus: selectedEditPatient?.maritalStatus,
        bloodGroup: selectedEditPatient?.bloodGroup,
        addressOne: selectedEditPatient?.address1,
        addressTwo: selectedEditPatient?.address2,
        city: selectedEditPatient?.city,
        patientState: selectedEditPatient?.state,
        country: selectedEditPatient?.country,
        pincode: selectedEditPatient?.pinCode,
        dob: selectedEditPatient?.dob ? dayjs(selectedEditPatient?.dob) : null,
        rpmChecked: selectedEditPatient?.rpmApplicable === "Y",
        sosChecked: selectedEditPatient?.sos === "Y",
        watchChecked: selectedEditPatient?.rpmSmartWatch === "Y",
        omronDevChecked: selectedEditPatient?.omranConnectYN === "Y",
        erContactNo1: selectedEditPatient?.erContactNo1,
        erContactNo2: selectedEditPatient?.erContactNo2,
        erContactNo3: selectedEditPatient?.erContactNo3,
        erContactNo4: selectedEditPatient?.erContactNo4,
        erContactNo5: selectedEditPatient?.erContactNo5,
      });
      fetchCities({ city_Name: selectedEditPatient?.city });
      fetchStates({ state_Id: selectedEditPatient?.state });
      setDob(selectedEditPatient?.dob);
      setRpmChecked(selectedEditPatient?.rpmApplicable === "Y");
      if (selectedEditPatient?.rpmApplicable === "Y") {
        dispatch(
          handleSetPatientRegistrationPayload({
            ...(registrationPayload || {}),
            rpmApplicable: "Y",
          }),
        );
      }
      setSosChecked(selectedEditPatient?.sos === "Y");
      setRpmWatchChecked(selectedEditPatient?.rpmSmartWatch === "Y");
      setSmartWatchId(selectedEditPatient?.smartWatchUserId);
      setOmronChecked(selectedEditPatient?.omranConnectYN === "Y");
      setOmronId(selectedEditPatient?.omranConnectId);
    }
  }, [selectedEditPatient]);

  useEffect(() => {
    if (fields.firstname)
      form.setFieldsValue({
        firstname:
          fields.firstname.charAt(0).toUpperCase() +
          fields.firstname.slice(1).toLowerCase(),
      });
    if (fields.lastname)
      form.setFieldsValue({
        lastname:
          fields.lastname.charAt(0).toUpperCase() +
          fields.lastname.slice(1).toLowerCase(),
      });
    if (fields.city)
      form.setFieldsValue({
        city:
          fields.city.charAt(0).toUpperCase() +
          fields.city.slice(1).toLowerCase(),
      });
  }, [fields]);

  // ── API helpers (unchanged) ──────────────────────────────────────────────────

  const getUsersList = async (filterVal) => {
    setIsLoading(true);
    const userPayload = { status: 1 };
    if (loggedUser?.user?.rolecode === "ACCT_ADM")
      userPayload.account_Id = loggedUser.user.account_Id;
    if (loggedUser?.user?.rolecode === "CLINIC_ADM") {
      userPayload.account_Id = loggedUser.user.account_Id;
      userPayload.clinic_Id = loggedUser.user.clinic_Id;
    }
    const finalPayload = filterVal
      ? { ...userPayload, ...filterVal }
      : userPayload;
    try {
      const response = await UserService.getUser(finalPayload);
      const userTypesToRemove = ["S", "M", "L"];
      const doctors = response?.data?.filter(
        (user) => !userTypesToRemove.includes(user.userType),
      );
      setUsersList(doctors);
      setFirstLoad(false);
      setIsLoading(false);
    } catch (e) {
      console.log(e);
      setIsLoading(false);
    }
  };

  const fetchCities = async (filterValues) => {
    const requestId = ++cityRequestRef.current;
    const payload = filterValues
      ? { status: 1, ...filterValues }
      : { status: 1 };
    try {
      const res = await CommonService.CitiesList(payload);
      if (requestId !== cityRequestRef.current) return;
      setCitiesList(res.data || []);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchStates = async (filterValues) => {
    const requestId = ++stateRequestRef.current;
    const payload = filterValues
      ? { status: 1, ...filterValues }
      : { status: 1 };
    try {
      const res = await CommonService.StatesList(payload);
      if (requestId !== stateRequestRef.current) return;
      setStatesList(res.data || []);
    } catch (e) {
      console.log(e);
    }
  };

  const handleSearchCities = (value) => {
    if (!value) {
      setCitiesList([]);
      return;
    }
    clearTimeout(searchTimeoutRef.current);
    searchTimeoutRef.current = setTimeout(
      () => fetchCities({ city_Name: value }),
      400,
    );
  };

  const handleStateChange = async (value) => {
    if (!value) {
      setCitiesList([]);
      return;
    }
    setCitiesList([]);
    await fetchCities({ state_Id: value });
  };

  const handleSearchStates = (value) => {
    if (!value) {
      setStatesList([]);
      return;
    }
    clearTimeout(stateSearchTimeoutRef.current);
    stateSearchTimeoutRef.current = setTimeout(
      () => fetchStates({ state_Name: value }),
      400,
    );
  };

  const handleCountryChange = async (value) => {
    if (!value) {
      setStatesList([]);
      return;
    }
    setStatesList([]);
    await fetchStates({ country_Id: value });
  };

  const handleClick = () => fileInputRef.current.click();
  const handleDob = (_, valueString) => setDob(valueString);
  const handleSelectDoctor = (userid) => {
    if (!userid) return;
    setSelectedDoctor(usersList.find((u) => u.userId === userid));
  };
  const handleDocSearch = (label) => {
    label?.length >= 2
      ? debouncedGetUsers({ userName: label })
      : debouncedGetUsers(null);
  };
  // Dispatch rpmApplicable to Redux IMMEDIATELY on checkbox change
  // so index.jsx reads isRpmEnabled live and unlocks tabs 2-5 instantly
  const handleRpmChange = () => {
    const next = !rpmChecked;
    setRpmChecked(next);
    dispatch(
      handleSetPatientRegistrationPayload({
        ...(registrationPayload || {}),
        rpmApplicable: next ? "Y" : "N",
      }),
    );
  };
  const handleRpmWatchChange = () => setRpmWatchChecked((v) => !v);
  const handleOmronChange = () => setOmronChecked((v) => !v);
  const handleSosChange = () => setSosChecked((v) => !v);
  const handleSmartWatchId = (e) => setSmartWatchId(e.target.value);
  const handleOmronId = (e) => setOmronId(e.target.value);

  const handleUserPicChange = async(e) => {
    const file = e.target.files[0];
    if (file && file.size <= 1048576){
        const res = await new Promise(resolve => {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
            const baseURL = reader.result;
            resolve({
                base64: baseURL.split(',')[1],
                type: file.type,
                name:file.name
            });
        };
        });
        console.log(res);
        setProfileImage(res);
      
    } 
    else message.error("Image size should be ≤ 1 MB");
  };

  // ── handlePatientSave
  // For non-RPM patients: validates + saves directly via API
  // For RPM patients: collectValues (already in useImperativeHandle) + handleNext()
  // Validation lives here for the DIRECT save path (non-RPM only)

  const handlePatientSave = async () => {
    const vals = formRef.current.getFieldValue();
    const {
      salutation,
      firstname,
      lastname,
      email,
      mobile,
      gender,
      maritalStatus,
      bloodGroup,
      addressOne,
      addressTwo,
      city,
      patientState,
      country,
      pincode,
      erContactNo1,
      erContactNo2,
      erContactNo3,
      erContactNo4,
      erContactNo5,
    } = vals;

    // if (!selectedEditPatient && !selectedDoctor) { message.error("Please select a doctor!!!"); return; }
    if (!firstname || !lastname || !mobile) {
      message.error("Please fill in all mandatory fields");
      return;
    }
    if (!/^\d{10,15}$/.test(mobile)) {
      message.error("Please enter a valid mobile number.");
      return;
    }
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      message.error("Please enter a valid mail id.");
      return;
    }
    if (pincode && country && !validatePostalCode(country, pincode)) {
      message.error("Please enter a valid pincode.");
      return;
    }
    if (
      sosChecked &&
      (!erContactNo1 || !erContactNo2 || !erContactNo3 || !erContactNo4)
    ) {
      message.error("Please fill in all mandatory SOS fields");
      return;
    }
    if (rpmWatchChecked && !smartWatchId) {
      message.error("Please fill in Watch Id");
      return;
    }
    if (omronChecked && !omronId) {
      message.error("Please fill in Omron connect Id");
      return;
    }

    // If RPM checked → just sync to Redux + go to next tab (final validation happens at Tab 5)
    if (rpmChecked) {
      await ref.current.collectValues(); // sync to Redux
      handleNext();
      return;
    }

    // Non-RPM → direct API save
    const currDate = new Date().toISOString().slice(0, 19).replace("T", " ");
    let payload = {};

    if (selectedEditPatient) {
      payload = {
        ...selectedEditPatient,
        firstName: firstname,
        lastName: lastname,
        mobile,
        email: email || null,
        salutation: salutation || null,
        gender,
        maritalStatus: maritalStatus || null,
        bloodGroup: bloodGroup || null,
        address1: addressOne || null,
        address2: addressTwo || null,
        city: city || null,
        state: patientState || null,
        country: country || null,
        pinCode: pincode || null,
        dob: dob || null,
        modifiedBy: loggedUser?.user?.userId,
        modifiedDate: currDate,
        status: 1,
        rpmApplicable: "N",
        sos: sosChecked ? "Y" : "N",
        erContactNo1: erContactNo1 || "",
        erContactNo2: erContactNo2 || "",
        erContactNo3: erContactNo3 || "",
        erContactNo4: erContactNo4 || "",
        erContactNo5: erContactNo5 || "",
        rpmSmartWatch: rpmWatchChecked ? "Y" : "N",
        smartWatchUserId: smartWatchId,
        omranConnectYN: omronChecked ? "Y" : "N",
        omranConnectId: omronId,
      };
    } else {
      const accountId = "77778888999";
      const clinicId = "C555566667777";
      const userId = "DOXZONADMIN";
      const userName = "Admin";

      payload = {
        account_Id: selectedDoctor ? selectedDoctor?.account_Id : accountId,
        clinic_Id: selectedDoctor ? selectedDoctor?.clinic_Id : clinicId,
        userId: selectedDoctor ? selectedDoctor?.userId : userId,
        userName: selectedDoctor ? selectedDoctor?.userName : userName,
        referralUserId: selectedDoctor ? selectedDoctor?.userId : userId,
        referralUserName: selectedDoctor ? selectedDoctor?.userName : userName,
        firstName: firstname,
        lastName: lastname,
        mobile,
        email: email || null,
        salutation: salutation || null,
        gender,
        maritalStatus: maritalStatus || null,
        bloodGroup: bloodGroup || null,
        address1: addressOne || null,
        address2: addressTwo || null,
        city: city || null,
        state: patientState || null,
        country: country || null,
        pinCode: pincode || null,
        dob: dob || null,
        createdBy: loggedUser?.user?.userId,
        createdDate: currDate,
        modifiedBy: loggedUser?.user?.userId,
        modifiedDate: currDate,
        status: 1,
        rpmApplicable: "N",
        patientChronicConditionsList: [],
        patientDevicesList: [],
        patientVitalsConfigList: {
          bloodGlucose: 0,
          bmi: 1,
          diastolic: 1,
          heartRate: 0,
          height: 1,
          respiratoryRate: 0,
          spo2: 0,
          systolic: 1,
          temperature: 0,
          weight: 1,
          breathing: 1,
          pulse: 1,
          spirometry: 1,
          createdBy: "",
          modifiedBy: "",
          status: 1,
        },
        patientVitalsRangeList: [],
        patientRegConsentDtlList: [],
        hospitalId: "",
        locationId: "",
        uhId: "",
        insuranceId1: "",
        insuranceId2: "",
        insuranceName1: "",
        insuranceName2: "",
        patientGroupNumber: "",
        height: 0,
        weight: 0,
        providerName: "",
        providerCode: "",
        sos: sosChecked ? "Y" : "N",
        erContactNo1: erContactNo1 || "",
        erContactNo2: erContactNo2 || "",
        erContactNo3: erContactNo3 || "",
        erContactNo4: erContactNo4 || "",
        erContactNo5: erContactNo5 || "",
        rpmSmartWatch: rpmWatchChecked ? "Y" : "N",
        smartWatchUserId: smartWatchId,
        omranConnectYN: omronChecked ? "Y" : "N",
        omranConnectId: omronId,
        loginId: null,
        loginIdAvailableYN: null,
        meetingLink: null,
        parentPatientId: null,
        parentPatientName: null,
        patientId: null,
        patientRegFee: 0,
        patientRegFeeYN: null,
        photo: null,
        photoName: null,
        photoType: null,
        relationCode: null,
        relationDescription: null,
        account_Name: null,
        clinic_Name: null,
      };
    }

    if (profileImage) {
      payload.photoName = profileImage.name;
      payload.photoType = profileImage.type;
      payload.photo = profileImage.base64;
    }

    setLoader(true);
    try {
      if (selectedEditPatient) {
        await PatientService.EditPatientData(payload);
        message.success("Patient Details updated successfully!!");
      } else {
        await PatientService.AddPatient(payload);
        message.success("Patient created successfully!!");
      }
      setProfileImage(null);
      formRef.current.resetFields();
      if (patientFilter) dispatch(clearPatientFilter(false));
      handleSave();
    } catch (e) {
      console.log(e);
      e?.response?.data?.message && message.error(e.response.data.message);
    } finally {
      setLoader(false);
    }
  };

  // ── Render ────────────────────────────────────────────────────────────────────

  return (
    <>
      {firstLoad ? (
        <div className="min-h-[50vh] flex items-center justify-center mt-[10%]">
          <Flex align="center" gap="middle">
            <Spin size="large" tip="Loading" />
          </Flex>
        </div>
      ) : (
        <>
          <div>
            <Form
              ref={formRef}
              form={form}
              disabled={loader}
              className="w-full border rounded-md"
            >
              {/* Profile image */}
              <div className="flex justify-between bg-[#F6FEFF] px-4 py-2 border-b">
                <div
                  className="flex items-center gap-3 cursor-pointer"
                  onClick={handleClick}
                >
                  <div className="relative w-28 h-28">
                    <input
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleUserPicChange}
                      ref={fileInputRef}
                    />
                    {profileImage ? (
                      <img
                        src={`data:${profileImage.type};base64,${profileImage.base64}`}
                        alt="Profile"
                        className="w-28 h-28 object-contain rounded-full border"
                      />
                    ) : selectedEditPatient?.photoName ? (
                      <Avatar
                        size={115}
                        src={
                          process.env.REACT_APP_IMAGE_URL +
                          selectedEditPatient?.photoName
                        }
                        alt="Profile"
                        className="w-28 h-28 object-cover rounded-full border"
                      />
                    ) : (
                      <div className="w-28 h-28 flex items-center justify-center rounded-full border bg-gray-100">
                        <span className="text-gray-500">No Image</span>
                      </div>
                    )}
                  </div>
                  <button className="bg-white border px-3 py-1 rounded-md font-semibold text-sm shadow-sm">
                    <span className="flex gap-2 items-center">
                      {profileImage || selectedEditPatient?.photoName ? (
                        <>
                          <MdOutlineEdit />
                          <span>Edit Photo</span>
                        </>
                      ) : (
                        <>
                          <CiCamera />
                          <span>Upload Photo</span>
                        </>
                      )}
                    </span>
                  </button>
                </div>
                <img src={regImg} alt="img" />
              </div>

              {/* User Details */}
              <div className="md:text-xl text-base font-medium px-4 my-2">
                User Details
              </div>
              <div className="w-full grid md:grid-cols-3 grid-cols-1 gap-4 px-4">
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Referral User
                    {/* <span className="text-red-500">*</span> */}
                  </span>
                  {selectedEditPatient ? (
                    <Form.Item name="userName" className="mt-1">
                      <Input
                        type="text"
                        className="rounded-md px-4 py-2"
                        disabled
                      />
                    </Form.Item>
                  ) : (
                    <Form.Item className="mt-1">
                      <Select
                        placeholder="Select User"
                        className="rounded-md h-10"
                        onChange={handleSelectDoctor}
                        onSearch={handleDocSearch}
                        showSearch
                        allowClear
                        filterOption={false}
                        options={usersList?.map((user, idx) => ({
                          label: `${user.firstName} ${user.lastName}`,
                          value: user.userId,
                          key: idx,
                        }))}
                        onClear={() => handleDocSearch(null)}
                        notFoundContent={
                          isLoading ? (
                            <div className="flex justify-center">
                              <Spin />
                            </div>
                          ) : (
                            <span>No data found</span>
                          )
                        }
                      />
                    </Form.Item>
                  )}
                </div>
              </div>

              {/* Personal Details */}
              <div className="md:text-xl text-base font-medium px-4 my-2">
                Personal Details
              </div>
              <div className="w-full grid md:grid-cols-3 grid-cols-1 gap-4 px-4">
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Salutation
                  </span>
                  <Form.Item name="salutation" className="mt-1">
                    <Select className="rounded-md h-10" allowClear>
                      <Select.Option value="Mr.">Mr</Select.Option>
                      <Select.Option value="Ms.">Ms</Select.Option>
                      <Select.Option value="Mrs.">Mrs</Select.Option>
                    </Select>
                  </Form.Item>
                </div>
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    First Name <span className="text-red-500">*</span>
                  </span>
                  <Form.Item name="firstname" className="mt-1">
                    <Input
                      className="rounded-md px-4 py-2"
                      onChange={(e) =>
                        setFields((p) => ({ ...p, firstname: e.target.value }))
                      }
                    />
                  </Form.Item>
                </div>
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Last Name <span className="text-red-500">*</span>
                  </span>
                  <Form.Item name="lastname" className="mt-1">
                    <Input
                      className="rounded-md px-4 py-2"
                      onChange={(e) =>
                        setFields((p) => ({ ...p, lastname: e.target.value }))
                      }
                    />
                  </Form.Item>
                </div>
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Mobile <span className="text-red-500">*</span>
                  </span>
                  <Form.Item name="mobile" className="mt-1">
                    <Input
                      maxLength={15}
                      className="rounded-md px-4 py-2"
                      onKeyDown={(e) => {
                        if (
                          !/[0-9]/.test(e.key) &&
                          ![
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ].includes(e.key)
                        )
                          e.preventDefault();
                      }}
                    />
                  </Form.Item>
                </div>
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Email
                  </span>
                  <Form.Item name="email" className="mt-1">
                    <Input type="email" className="rounded-md px-4 py-2" />
                  </Form.Item>
                </div>
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Date of Birth
                  </span>
                  <Form.Item name="dob" className="mt-1">
                    <DatePicker
                      className="w-full rounded-md px-2 py-2"
                      format="MM/DD/YYYY"
                      onChange={handleDob}
                      disabledDate={(c) => c && c > Date.now()}
                    />
                  </Form.Item>
                </div>
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Gender
                  </span>
                  <Form.Item name="gender" className="mt-1">
                    <Select className="rounded-md h-10" allowClear>
                      <Select.Option value="M">Male</Select.Option>
                      <Select.Option value="F">Female</Select.Option>
                    </Select>
                  </Form.Item>
                </div>
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Marital Status
                  </span>
                  <Form.Item name="maritalStatus" className="mt-1">
                    <Select className="rounded-md h-10" allowClear>
                      <Select.Option value="M">Married</Select.Option>
                      <Select.Option value="U">Unmarried</Select.Option>
                    </Select>
                  </Form.Item>
                </div>
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Blood Group
                  </span>
                  <Form.Item name="bloodGroup" className="mt-1">
                    <Select className="rounded-md h-10" allowClear>
                      {bloodgroup.map((b) => (
                        <Select.Option key={b} value={b}>
                          {b}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>

              {/* Address Details */}
              <div className="md:text-xl text-base font-medium px-4 my-2">
                Address Details
              </div>
              <div className="w-full grid md:grid-cols-4 grid-cols-1 gap-4 px-4">
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Address 1
                  </span>
                  <Form.Item name="addressOne" className="mt-1">
                    <Input className="rounded-md px-4 py-2" />
                  </Form.Item>
                </div>
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Address 2
                  </span>
                  <Form.Item name="addressTwo" className="mt-1">
                    <Input className="rounded-md px-4 py-2" />
                  </Form.Item>
                </div>
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    City
                  </span>
                  <Form.Item name="city" className="mt-1">
                    <Select
                      showSearch
                      className="rounded-md h-10"
                      options={citiesList?.map((c) => ({
                        label: c.cityName,
                        value: c.cityName,
                        key: c.id,
                      }))}
                      onSearch={handleSearchCities}
                      filterOption={false}
                      allowClear
                    />
                  </Form.Item>
                </div>
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    State
                  </span>
                  <Form.Item name="patientState" className="mt-1">
                    <Select
                      showSearch
                      className="rounded-md h-10"
                      options={statesList?.map((s) => ({
                        label: s.stateName,
                        value: s.stateId,
                        key: s.id,
                      }))}
                      onChange={handleStateChange}
                      onSearch={handleSearchStates}
                      filterOption={false}
                      allowClear
                    />
                  </Form.Item>
                </div>
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Country
                  </span>
                  <Form.Item name="country" className="mt-1">
                    <Select
                      showSearch
                      className="rounded-md h-10"
                      onChange={handleCountryChange}
                      options={countries?.map((c) => ({
                        label: c.country_Name,
                        value: c.country_Id,
                        key: c.id,
                      }))}
                      filterOption={(i, o) =>
                        o.label.toLowerCase().includes(i.toLowerCase())
                      }
                      allowClear
                    />
                  </Form.Item>
                </div>
                <div className="relative">
                  <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                    Pincode
                  </span>
                  <Form.Item name="pincode" className="mt-1">
                    <Input
                      className="rounded-md px-4 py-2"
                      onKeyDown={(e) => {
                        if (
                          !/[0-9]/.test(e.key) &&
                          ![
                            "Backspace",
                            "Delete",
                            "Tab",
                            "ArrowLeft",
                            "ArrowRight",
                          ].includes(e.key)
                        )
                          e.preventDefault();
                      }}
                    />
                  </Form.Item>
                </div>
                <div className="flex gap-2">
                  <Form.Item valuePropName="checked" name="rpmChecked">
                    <Checkbox onChange={handleRpmChange} />
                  </Form.Item>
                  <label className="md:text-lg text-base font-medium">
                    RPM
                  </label>
                </div>
                <div className="flex gap-2">
                  <Form.Item valuePropName="checked" name="sosChecked">
                    <Checkbox onChange={handleSosChange} />
                  </Form.Item>
                  <label className="md:text-lg text-base font-medium">
                    SOS
                  </label>
                </div>
                {sosChecked && (
                  <>
                    {[
                      "erContactNo1",
                      "erContactNo2",
                      "erContactNo3",
                      "erContactNo4",
                    ].map((name, i) => (
                      <div className="relative" key={name}>
                        <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                          Contact {i + 1}
                          <span className="text-red-500">*</span>
                        </span>
                        <Form.Item name={name}>
                          <Input
                            className="rounded-md px-4 py-2"
                            maxLength={10}
                            onKeyDown={(e) => {
                              if (
                                !/[0-9]/.test(e.key) &&
                                ![
                                  "Backspace",
                                  "Delete",
                                  "Tab",
                                  "ArrowLeft",
                                  "ArrowRight",
                                ].includes(e.key)
                              )
                                e.preventDefault();
                            }}
                          />
                        </Form.Item>
                      </div>
                    ))}
                    <div className="relative">
                      <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                        Contact 5 (Medical)
                      </span>
                      <Form.Item name="erContactNo5">
                        <Input
                          className="rounded-md px-4 py-2"
                          maxLength={10}
                          onKeyDown={(e) => {
                            if (
                              !/[0-9]/.test(e.key) &&
                              ![
                                "Backspace",
                                "Delete",
                                "Tab",
                                "ArrowLeft",
                                "ArrowRight",
                              ].includes(e.key)
                            )
                              e.preventDefault();
                          }}
                        />
                      </Form.Item>
                    </div>
                  </>
                )}
              </div>

              {/* RPM Watch */}
              <div className="w-full grid md:grid-cols-4 grid-cols-1 gap-4 px-4">
                <div className="flex gap-2">
                  <Form.Item valuePropName="checked" name="watchChecked">
                    <Checkbox
                      checked={rpmWatchChecked}
                      onChange={handleRpmWatchChange}
                    />
                  </Form.Item>
                  <label className="md:text-lg text-base font-medium">
                    Rpm-Watch
                  </label>
                </div>
                {rpmWatchChecked && (
                  <div className="relative">
                    <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                      Watch Id
                    </span>
                    <Form.Item>
                      <Input
                        placeholder="Enter watch-Id"
                        value={smartWatchId}
                        onChange={handleSmartWatchId}
                        className="rounded-md px-4 py-2"
                      />
                    </Form.Item>
                  </div>
                )}
              </div>

              {/* Omron */}
              <div className="w-full grid md:grid-cols-4 grid-cols-1 gap-4 px-4">
                <div className="flex gap-2">
                  <Form.Item valuePropName="checked" name="omronDevChecked">
                    <Checkbox
                      checked={omronChecked}
                      onChange={handleOmronChange}
                    />
                  </Form.Item>
                  <label className="md:text-lg text-base font-medium">
                    Omron Device
                  </label>
                </div>
                {omronChecked && (
                  <div className="relative">
                    <span className="absolute -top-1 z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
                      Omron Id
                    </span>
                    <Form.Item>
                      <Input
                        placeholder="Enter Omron-Id"
                        value={omronId}
                        onChange={handleOmronId}
                        className="rounded-md px-4 py-2"
                      />
                    </Form.Item>
                  </div>
                )}
              </div>
            </Form>
          </div>

          <div className="flex md:flex-row text-center flex-col md:items-center items-end justify-end gap-3 mt-4">
            <button
              disabled={loader}
              className="md:min-w-24 w-[3rem] md:w-24 h-8 p-1 bg-white rounded-lg border text-brand-primaryColor border-brand-primaryColor font-semibold custom-button-shadow"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              disabled={loader}
              className="md:min-w-24 w-[3rem] md:w-24 h-8 p-1 custom_filter text-white rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-50"
              onClick={handlePatientSave}
            >
              {rpmChecked ? "Next" : selectedEditPatient ? "Update" : "Save"}
            </button>
          </div>
        </>
      )}
    </>
  );
}

export default forwardRef(PatientBasicDetails);
